module.exports = __webpack_public_path__ + "static/img/qr-code.00f0855.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/footer/qr-code.png
// module id = i9fi
// module chunks = 48